import { useMutation, useQueryClient } from '@tanstack/react-query';
import { preferencesKeys } from '../query-keys';
import { deleteBoardPreference } from '../requests';
import type {
  DeleteBoardPreferenceRequest,
  GetPreferenceResponse,
} from '../types';

export const useDeleteBoardPreference = <
  T extends Record<string, unknown>,
>() => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: DeleteBoardPreferenceRequest) =>
      deleteBoardPreference<T>(params),
    onSuccess: (response, variables) => {
      queryClient.setQueryData<GetPreferenceResponse<T>>(
        preferencesKeys.key(variables.boardId, variables.key),
        response,
      );
    },
  });
};
